import { loadJson, saveJson } from 'util/storage'
import { extractList } from 'util/string'

export type AuAuth = {
  access_token: string
  expires_in: number
  id_token: string
  refresh_token: string
  scope: string
  token_type: string
}

export type AuUserInfo = {
  email?: string
  email_verified?: string
  family_name?: string
  given_name?: string
  locale?: string
  name?: string
  nickname?: string
  picture?: string
  sub?: string
  updated_at?: string

  // custom
  showoff_user_id: string
}

export type AuConItem = {
  display_name?: string
  id: string
  name: string
  options?: {
    client_secret?: string
  }
  enabled_clients: string[]
}

export type AuRefresh = {
  access_token: string
  expires_in: number
  id_token: string
  scope: string
  token_type: string
}

export type Connection = {
  name: string
  title: string
  url: string
}

export type Auth = {
  access_token?: string
  expires_in?: number
  id_token: string
  refresh_token: string
}

export type User = {
  user_id: string
  email?: string
  name?: string
  picture?: string
  password?: boolean
  test?: boolean
}

export type Me = {
  auth: Auth | undefined
  user: User
}

export type Company = {
  company_id: string,
  permissions?: string,
}

export type Permissions = {
  credits: number
  roles: {
    is_admin: boolean
    is_external: number
  }
  companies: Company[]
}

export type LoginData = {
  auth: Auth
  user: User
  permissions: Permissions
}

export type MeData = {
  auth?: Auth
  user: User
  permissions: Permissions
}

export type LoginResult = 'failed' | 'not_allowed' | 'success'

export type ExistingUser = {
  user_id: string
  manager_id?: string
  user_name: string
  user_phone: string,
  user_email: string
  user_pic: string
  user_descr: string,
  access_key: string
  is_external: number
  personal_data_consent: number
  companies: string[]
}

export function loadAuth(): Auth | undefined {
  return loadJson('boutique.auth')
}

export function saveAuth(auth: Auth | undefined): void {
  saveJson('boutique.auth', auth)
}

export function loadManagers(): Me[] | undefined {
  return loadJson('boutique.managers')
}

export function addManager(data: Me): void {
  let managers = loadManagers() || []
  managers = managers.filter(m => m.user.user_id !== data.user.user_id)
  managers.unshift(data)
  saveJson('boutique.managers', managers)
}

export function removeManager(user_id: string): void {
  let managers = loadManagers() || []
  managers = managers.filter(m => m.user.user_id !== user_id)
  saveJson('boutique.managers', managers)
}

export function isBoutiqueManager(permissions: Permissions, company: string): boolean {
  if (!company) return false

  const { roles, companies } = permissions
  if (roles.is_admin) return true

  const ROLES = ['system_admin', 'admin', 'boutique_manager']
  const allow = !!companies.find(c => c.company_id === company
    && extractList(c.permissions).some(r => ROLES.includes(r)))
  return allow
}
